import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSchool1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M11 21h19v11H11z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M18 24h-4v8h4z"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M11 9h10v10H11z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M11 16h19v5H11z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M29 17v3h-2v-3zM26 17v3h-2v-3zM23 17v3h-2v-3zM20 17v3h-2v-3zM17 17v3h-2v-3zM14 17v3h-2v-3z"
    />
    <circle
      cx={16}
      cy={13}
      r={2}
      fill="#00C5F2"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSchool1);

export default ForwardRef;
